import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";

import { cn } from "@/lib/utils";

const badgeVariants = cva(
  "inline-flex items-center rounded-md border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground shadow hover:bg-primary-700",
        secondary:
          "border-transparent bg-secondary-200 text-secondary-foreground hover:bg-secondary-300",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground shadow hover:bg-error-300",
        success:
          "border-transparent bg-success text-success-foreground shadow hover:bg-success-300",
        warning:
          "border-transparent bg-warning text-warning-foreground shadow hover:bg-warning-300",
        outline: "text-foreground border-secondary-400",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

export interface BadgeProps
  extends
    React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
